import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'
import * as moment from 'moment'
import {Router}from'@angular/router';
import {DetalleServiceService }from'../detalle-service.service'

@Component({
  selector: 'app-componente-data4',
  templateUrl: './componente-data4.component.html',
  styleUrls: ['./componente-data4.component.scss']
})
export class ComponenteData4Component implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};

  dtTrigger: Subject<ComponenteData4Component> = new Subject();

  arraydeposts=[]
  nombre='';
  email='';
  password='';
  empresa='';
  alertaActiva=false;
  creandousuario=false
  cuencaActiva=''
  ultimaActualizacion=''

  botondisabled=true

  botonactivo={vmm:'btn btn-outline-secondary',vmmOtros:'btn btn-outline-secondary',VMMSRTSQ:'btn btn-outline-secondary',putNorte:'btn btn-outline-secondary',putSur:'btn btn-outline-secondary',bogota:'btn btn-outline-secondary',nacional:'btn btn-outline-secondary', iguana:'btn btn-outline-secondary', chanangue:'btn btn-outline-secondary',charapa:'btn btn-outline-secondary', ecuador:'btn btn-outline-secondary'}


  constructor(private modalService: NgbModal, private router:Router, public detalleService:DetalleServiceService) { }


  ngOnInit() {
    this.inicializadatatables(()=>{
      this.botonactivo.vmm='btn btn-outline-primary';
      this.query1("VMM",()=>{
        this.dtTrigger.next();
        this.cuencaActiva="VMM"
        this.iniciaTimer()
      });
    })
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }



 

  ngAfterViewInit(): void {
    
  }


  iniciaTimer(){
    //el timer se repite cada 6 horas para recargar la data
    let fecha = new Date();
    this.ultimaActualizacion = fecha.toLocaleTimeString()
    setInterval( ()=>{this.seleccionaCuenca(this.cuencaActiva)} ,21600000) //21600000 milisegundoss son 6 horas
  }



  rerender(callback): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
        // Destroy the table first
        dtInstance.destroy();
        //reload your data
        // this.query1(()=>{
        //    // Call the dtTrigger to rerender after callback
        //    this.dtTrigger.next();
        // })
        let fecha = new Date();
        this.ultimaActualizacion = fecha.toLocaleTimeString()
        callback()
      });
  }

  query1(cuenca, callback){
    this.alertaActiva=true
    let fechahoy =  moment().format('YYYY-MM-DD')
    this.arraydeposts=[];

    if(cuenca!="Nacional" && cuenca!="Ecuador"){
          let query1 = firebase.firestore().collection("ptws").where("fechafinal",">=",fechahoy).where("status","in",["Aprobado","Denegado","Pendiente de aprobación","Cerrado"]).where("cuenca","==",cuenca);
        query1.get().then((docs)=>{
          docs.forEach((doc)=>{
            this.arraydeposts.push(doc);
          })
        }).then(()=>{
          callback()
        }).catch((err)=>{
          console.log(err);
        })
    }else
    if(cuenca=="Nacional"){
        //  let query1 = firebase.firestore().collection("ptws").where("fechafinal",">=",fechahoy).where("status","in",["Aprobado","Denegado","Pendiente de aprobación","Cerrado"])
        let query1 = firebase.firestore().collection("ptws").where("fechafinal",">=",fechahoy).where("cuenca","in",["Bogota","Llanos","Putumayo norte","Putumayo sur","VMM","VMM-otros",])
        query1.get().then((docs)=>{
          docs.forEach((doc)=>{
            if(doc.data().status == "Aprobado" || doc.data().status == "Denegado" || doc.data().status == "Pendiente de aprobación" || doc.data().status == "Cerrado" ){
              this.arraydeposts.push(doc);
            }
          })
        }).then(()=>{
          callback()
        }).catch((err)=>{
          console.log(err);
        })
    }else
    if(cuenca=="Ecuador"){
        let query1 = firebase.firestore().collection("ptws").where("fechafinal",">=",fechahoy).where("cuenca","in",["Charapa","Chanangue","Iguana"])
          query1.get().then((docs)=>{
            docs.forEach((doc)=>{
              if(doc.data().status == "Aprobado" || doc.data().status == "Denegado" || doc.data().status == "Pendiente de aprobación" || doc.data().status == "Cerrado" ){
                this.arraydeposts.push(doc);
              }
            })
          }).then(()=>{
            callback()
          }).catch((err)=>{
            console.log(err);
          })
    }
    
    // query1.onSnapshot((docs)=>{
    //   console.log("snapshot!")
    //   this.alertaActiva=true
    //   this.arraydeposts=[]
    //   this.rerender(()=>{
    //     docs.forEach((doc)=>{
    //       this.arraydeposts.push(doc)
    //     })
    //     this.dtTrigger.next();
    //   })
    // })
  }

  
  

  
  seleccionaCuenca(cuenca){
      this.cuencaActiva=cuenca
      this.resaltabotones(cuenca)
      this.rerender(()=>{
          this.query1(cuenca,()=>{
            this.dtTrigger.next()
          })
      })
  }

  resaltabotones(cuenca){
    if(cuenca=='VMM'){this.botonactivo.vmm='btn btn-outline-primary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='VMM-otros'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-primary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='VMM - SR & TSQ'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-primary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='Putumayo norte'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-primary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='Putumayo sur'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-primary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='Bogota'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-primary',this.botonactivo.nacional='btn btn-outline-secondary'}else
    if(cuenca=='Nacional'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-primary'}
    if(cuenca=='Nacional'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-primary'}
    if(cuenca=='Nacional'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-primary'}
    if(cuenca=='Nacional'){this.botonactivo.vmm='btn btn-outline-secondary'; this.botonactivo.vmmOtros='btn btn-outline-secondary'; this.botonactivo.putNorte='btn btn-outline-secondary'; this.botonactivo.putSur='btn btn-outline-secondary'; this.botonactivo.bogota='btn btn-outline-secondary',this.botonactivo.nacional='btn btn-outline-primary'}
    
  
  }

  inicializadatatables(callback) {
    this.dtOptions = {
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      "pageLength": 100,
      scrollX: false,
      // Configure the buttons
      buttons: [
        'colvis',
        'excel',
      ],

      //init comlete es un evento que se dispara cuando la tabla ya está dibujada completamente. 
      //en este caso la usamos para destruir el spinner
      initComplete:()=>{
        this.alertaActiva=false
      }

    };
    callback()
  }


validaboton(){
  console.log("validaboton activado")
  if(this.email!=''&&this.nombre!=''&&this.password!=''){
    this.botondisabled=false
  }else{
    this.botondisabled=true
  }
}


detalle(item){
  this.detalleService.dataPTW=item
  this.router.navigateByUrl('/ComponenteData7Component');
}







  closeAlert(){
    this.alertaActiva=false
  }


  detallesUsuario(usuario){
    const modalRef = this.modalService.open(ModalAccionesUsuarioComponent);
    modalRef.componentInstance.usuario = usuario;//pasamos al modal el parámetro de usuario
  
    //para recibir data desde el modal
    modalRef.result.then((result) => {
      if (result=="OK") {
      this.rerender(()=>{
        
      })
      }
      });
  }



}//fin de clase

